import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { TransactionsPage } from '@/features/transactions/TransactionsPage';
import { CardsPage } from '@/features/cards/CardsPage';
import { InvoicePanel } from '@/features/cards/InvoicePanel';
import { AccountsPage } from '@/features/accounts/AccountsPage';
import { CategoriesPage } from '@/features/categories/CategoriesPage';
import { TagsPage } from '@/features/tags/TagsPage';
import { ReportsPage } from '@/features/reports/ReportsPage';
import { FortnightlyReportPage } from '@/features/reports/FortnightlyReportPage';
import { BudgetsPage } from '@/features/budgets/BudgetsPage';
import { ExpenseCalendarPage } from '@/features/calendar/ExpenseCalendarPage';
import { MorePage } from '@/features/more/MorePage';
import { LoginPage } from '@/features/auth/LoginPage';
import { RegisterPage } from '@/features/auth/RegisterPage';
import { RequireAuth } from '@/features/auth/RequireAuth';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { OpenFinanceReviewPage } from '@/features/open-finance/OpenFinanceReviewPage';
import { refreshSession } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

export function App() {
  const status = useAuthStore((s) => s.status);

  // bootstrap: tenta renovar a sessão pelo cookie httpOnly uma única vez
  useEffect(() => {
    void refreshSession().then((ok) => {
      if (!ok) useAuthStore.getState().setGuest();
    });
  }, []);

  return (
    <Routes>
      {/* rotas públicas, fora do AppShell */}
      <Route
        path="/login"
        element={status === 'authed' ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route
        path="/registro"
        element={status === 'authed' ? <Navigate to="/" replace /> : <RegisterPage />}
      />

      {/* app autenticado */}
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/transacoes" element={<TransactionsPage />} />
        <Route path="/cartoes" element={<CardsPage />} />
        <Route path="/cartoes/:id" element={<InvoicePanel />} />
        <Route path="/contas" element={<AccountsPage />} />
        <Route path="/categorias" element={<CategoriesPage />} />
        <Route path="/tags" element={<TagsPage />} />
        <Route path="/relatorios" element={<ReportsPage />} />
        <Route path="/relatorios/quinzenal/:reportId" element={<FortnightlyReportPage />} />
        <Route path="/orcamentos" element={<BudgetsPage />} />
        <Route path="/calendario" element={<ExpenseCalendarPage />} />
        <Route path="/mais" element={<MorePage />} />
        <Route path="/config" element={<SettingsPage />} />
        <Route path="/movimentacoes/reviews" element={<OpenFinanceReviewPage />} />
        <Route path="/open-finance/reviews" element={<Navigate to="/movimentacoes/reviews" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
